import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const QueryStudioShotReport = (params?: Record<string, unknown>) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.StudioShotReportQueryURL.QueryStudioShotReport,
        method: RequestType.GET,
        params,
    });

export const StudioShotReportQuery = {
    QueryStudioShotReport,
};
